import createReducer from "../createReducer";
import { disconnectIntegrationHandlers } from "./handlers";
import { IDisconnectIntegrationState } from "./types";

export const disconnectIntegrationState: IDisconnectIntegrationState = {
    success: false,
    message: "",
    data: null,
};

export default createReducer(disconnectIntegrationState, disconnectIntegrationHandlers);
